/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgActivityList = (props: Props) => (
  <Icon viewBox="0 0 24 23" {...props}>
    <g fill="none">
      <path
        d="M6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm4 2a4.002 4.002 0 0 1-3 3.874v3.252A4.002 4.002 0 0 1 6 21a4 4 0 0 1-1-7.874V9.874A4.002 4.002 0 0 1 6 2a4 4 0 0 1 4 4zm-4 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM22 5H12V3h10zm0 11H12v-2h10zM12 9h7V7h-7zm7 11h-7v-2h7z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgActivityList as ActivityList };
